<template>

  <div
    style="height: 100%;"
    class="p-3">

    <div
      style="overflow: hidden;">
      <div class="row">
        <div class="col-sm-9">
          <div v-if="['published'].includes(job.publicate)">
            <JobAdvertiseBoards />
          </div>
          <div
            v-if="!['published'].includes(job.publicate)"
            :class="{'box-loading': loading}">
            <h5>A vaga não está publicada.</h5>
            <p class="text-muted">Para divulgar a vaga em job boards parceiros, a vaga precisa estar publicada.</p>
            <p v-if="permissions.includes('manage_jobs')">
              <a href="javascript:join(0)" @click="publish">Publicar vaga.</a>
            </p>
          </div>
        </div>
        <div
          v-if="['published', 'unlisted'].includes(job.publicate)"
          class="col-sm-3">
          <JobAdvertiseShare />
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import JobAdvertiseBoards from './JobAdvertiseBoards'
import JobAdvertiseShare from './JobAdvertiseShare'

export default {
  name: 'JobAdvertise',
  components: {
    JobAdvertiseBoards,
    JobAdvertiseShare
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    job () {
      return this.$store.getters.getJob
    }
  },
  created () {
    if (this.job.is_talent_pool) {
      return this.$router.push(`/job/${this.job._id}/grid`)
    }
  },
  methods: {
    publish () {
      this.loading = true
      this.$store.dispatch('updateJob', {
        _id: this.job._id,
        publicate: 'published'
      }).then(() => {
        this.loading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Job/JobAdvertise/JobAdvertise.vue